module.exports = () => {
  const btns = document.querySelectorAll('.video-button')
  const modalRoot = document.getElementById('modal-root')

  for (const el of btns) {
    const videoUrl = el.getAttribute('data-url')

    if (videoUrl) {
      const openModalHandler = e => {
        const template = `
          <div class="bg-black-60 fixed h-full w-full inset-0 flex items-center justify-center p-4">
            <div id="video-modal" class="relative bg-white rounded shadow-lg w-full max-w-4xl">
              <div class="rounded overflow-hidden">
                <iframe
                  class="max-w-full"
                  title="video-modal"
                  width="896"
                  height="504"
                  src="${videoUrl}"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <div class="absolute right-0 top-0">
                <button class="video-modal-close-btn w-10 h-10 bg-gray-900 rounded-full ovreflow-hidden -mr-5 -mt-5 focus:outline-none">
                  <svg class="w-10 h-10 text-white fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"></path></svg>
                </button>
              </div>
            </div>
          </div>
        `

        modalRoot.innerHTML = template

        setTimeout(() => {
          const modal = document.getElementById('video-modal')
          const closeBtn = document.querySelector('.video-modal-close-btn')

          const closeModalHandler = e => {
            if (!modal.contains(e.target)) {
              modal.parentElement.removeEventListener('click', closeModalHandler)
              closeBtn.removeEventListener('click', btnCloseModalHandler)
              modalRoot.innerHTML = ''
            }
          }

          const btnCloseModalHandler = e => {
            modal.parentElement.removeEventListener('click', closeModalHandler)
            closeBtn.removeEventListener('click', btnCloseModalHandler)
            modalRoot.innerHTML = ''
          }

          closeBtn.addEventListener('click', btnCloseModalHandler)
          modal.parentElement.addEventListener('click', closeModalHandler)
        }, 100)
      }

      el.addEventListener('click', openModalHandler)
    }
  }
}
